module.exports = __webpack_public_path__ + "img/meta.c14e1218.svg";